import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { ProductDto } from '../types/dtos';
import { APP_ENDPOINTS } from 'app/endpoints';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, ProductDto>({
        query: (payload) => ({
            url: APP_ENDPOINTS.PRODUCTS,
            method: 'POST',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'products-with-join', id: 'GET-JOIN' },
            { type: 'products', id: 'GET' },
        ],
    });
